import React from 'react';

interface TestModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}

const TestModal: React.FC<TestModalProps> = ({ isOpen, onClose, title, children }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 overflow-auto">
      <div className="fixed inset-0 bg-black opacity-50" onClick={onClose}></div>
      <div className="bg-white p-4 rounded shadow-lg z-10 max-w-lg mx-4 w-full max-h-full overflow-y-auto">
        <h2 className="text-xl font-semibold">{title}</h2>
        <div className="mt-2">{children}</div>
        <button
          onClick={onClose}
          className="mt-4 px-4 py-2 bg-purple-800 text-white rounded hover:bg-purple-600 focus:outline-none focus:ring-2 focus:ring-purple-800 focus:ring-opacity-50 w-full"
        >
          Тестийг үргэлжлүүлэх
        </button>
      </div>
    </div>
  );
};

export default TestModal;